var addFuelDispenser = (function () {
  const init = function () {
    setupComponentSelector(
      "#add-pump-dropdown",
      ".pump-dropdown",
      "#SelectedPumpIdValidation"
    );
    setupComponentSelector(
      "#add-meter-dropdown",
      ".meter-dropdown",
      "#SelectedMeterIdValidation"
    );
    setupComponentSelector(
      "#add-filter-dropdown",
      ".filter-dropdown",
      "#SelectedFilterIdValidation"
    );
    setupComponentSelector(
      "#add-nozzle-dropdown",
      ".nozzle-dropdown",
      "#SelectedNozzleIdValidation"
    );
    setupComponentSelector(
      "#add-dischargeKit-dropdown",
      ".discharge-kit-dropdown",
      "#SelectedDischargeKitIdValidation"
    );
    setupComponentSelector(
      "#add-sectionKit-dropdown",
      ".section-kit-dropdown",
      "#SelectedSuctionKitIdValidation"
    );

    $(".fuel-dispenser-model-dropdown").change(function () {
      $("#SelectedFuelDispenserModelIdValidation").hide();
    });
    $(".hardware-dropdown").change(function () {
      $("#SelectedHardwareIdValidation").hide();
      requestFirmwaresBySelectedComponents();
    });
    $(".bootloader-dropdown").change(function () {
      $("#SelectedBootloaderIdValidation").hide();
      requestFirmwaresBySelectedComponents();
    });
    $(".firmware-dropdown").change(function () {
      $("#SelectedFirmwareIdValidation").hide();
    });

    function requestFirmwaresBySelectedComponents() {
      if (
        hasValue($(".hardware-dropdown")) &&
        hasValue($(".bootloader-dropdown"))
      ) {
        $.ajax({
          url: "/Firmwares/GetByComponents",
          method: "GET",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: {
            hardwareId: $(".hardware-dropdown").val(),
            bootloaderId: $(".bootloader-dropdown").val(),
          },
          success: function (data) {
            rebuildSelectorOptions(".firmware-dropdown", data);
          },
          error: function () {},
        });
      }
    }

    function rebuildSelectorOptions(selectCss, options) {
      $(selectCss + " option").each(function () {
        if (this.hasAttribute("data-id")) {
          var enableOption =
            options.filter((obj) => {
              return obj.id === $(this).data("id");
            }).length > 0
              ? true
              : false;
          if (enableOption) {
            $(this).removeAttr("disabled");
          } else {
            $(this).attr("disabled", "disabled");
          }
          $(this).prop("selected", false);
        } else {
          $(this).prop("selected", true);
        }
      });
    }

    function setupComponentSelector(componentId, selectCss, errorId) {
      $(componentId).click(function () {
        const $dropdownList = $(this).parents(".dropdown-list");
        $dropdownList.append(buildAdditionalDropdown($dropdownList));
      });
      $(selectCss).change(function () {
        $(errorId).hide();
      });
    }

    function buildAdditionalDropdown($dropdownList) {
      const $additionalDropdown = $(
        '<div class="additional-dropdown"></div>'
      ).append($dropdownList.find(".dropdown select").clone());

      const $removeIcon = $(
        '<i class="mdi mdi-close-circle-outline remove-component-button"></i>'
      ).on("click", function () {
        $(this).parent().remove();
      });

      $additionalDropdown.find("select").after($removeIcon);
      return $additionalDropdown;
    }

    $("#add-fuel-dispenser-button").on("click", function () {
      if (validate() === false) {
        return;
      }

      const viewModel = {
        FuelDispenserDetailsViewModel: {
          SerialNumber: $("#SerialNumber").val(),
          State: $("#State").val(),
          ActivationCode: $("#ActivationCode").val(),
          ApiKey: $("#ApiKey").val(),
          ResponseTimeInDays: $("#ResponseTimeInDays").val(),
          Comment: $("#Comment").val(),
          SelectedHardwareId: $(".hardware-dropdown").val(),
          SelectedBootloaderId: $(".bootloader-dropdown").val(),
          SelectedFirmwareId: $(".firmware-dropdown").val(),
        },
        SelectedIqModelId: $(".fuel-dispenser-model-dropdown").val(),
        SelectedPumpIds: selectValues($(".pump-dropdown")),
        SelectedMeterIds: selectValues($(".meter-dropdown")),
        SelectedFilterIds: selectValues($(".filter-dropdown")),
        SelectedNozzleIds: selectValues($(".nozzle-dropdown")),
        SelectedDischargeKitIds: selectValues($(".discharge-kit-dropdown")),
        SelectedSuctionKitIds: selectValues($(".suction-kit-dropdown")),
      };

      $.ajax({
        url: "/FuelDispensers/Add",
        method: "POST",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(viewModel),
      }).done(function (data) {
        if (data.success) {
          $.notificationSuccess(data.header, data.message);
          setTimeout(function () {
            document.location = "/FuelDispensers/Index";
          }, reloadDelay);
        } else {
          showServerValidation(data.validationErrors);
        }
      });
    });

    function validate() {
      var isValid = true;
      $(".validation").hide();
      if (!hasValue($("#SerialNumber"))) {
        $("#SerialNumberValidation").show();
        isValid = false;
      }
      if (!hasValue($("#ActivationCode"))) {
        $("#ActivationCodeValidation").show();
        isValid = false;
      }
      if (!hasValue($("#ResponseTimeInDays"))) {
        $("#ResponseTimeInDaysValidation").show();
        isValid = false;
      }
      if (hasValue($("#ResponseTimeInDays"))) {
        if ($("#ResponseTimeInDays").val() <= 0) {
          $("#WrongResponseTimeInDays").show();
          isValid = false;
        }
      } else {
        $("#ResponseTimeInDaysValidation").show();
        isValid = false;
      }

      if (!hasAtLeastOneValue($(".fuel-dispenser-model-dropdown"))) {
        $("#SelectedFuelDispenserModelIdValidation").show();
        isValid = false;
      }
      if (!hasAtLeastOneValue($(".pump-dropdown"))) {
        $("#SelectedPumpIdValidation").show();
        isValid = false;
      }
      if (!hasAtLeastOneValue($(".meter-dropdown"))) {
        $("#SelectedMeterIdValidation").show();
        isValid = false;
      }
      if (!hasAtLeastOneValue($(".filter-dropdown"))) {
        $("#SelectedFilterIdValidation").show();
        isValid = false;
      }
      if (!hasAtLeastOneValue($(".nozzle-dropdown"))) {
        $("#SelectedNozzleIdValidation").show();
        isValid = false;
      }
      if (!hasAtLeastOneValue($(".discharge-kit-dropdown"))) {
        $("#SelectedDischargeKitIdValidation").show();
        isValid = false;
      }
      if (!hasAtLeastOneValue($(".suction-kit-dropdown"))) {
        $("#SelectedSuctionKitIdValidation").show();
        isValid = false;
      }
      if (!hasValue($(".hardware-dropdown"))) {
        $("#SelectedHardwareIdValidation").show();
        isValid = false;
      }
      if (!hasValue($(".bootloader-dropdown"))) {
        $("#SelectedBootloaderIdValidation").show();
        isValid = false;
      }
      if (!hasValue($(".firmware-dropdown"))) {
        $("#SelectedFirmwareIdValidation").show();
        isValid = false;
      }
      return isValid;
    }

    function hasValue($field) {
      return $field.val() ? $field.val().length !== 0 : false;
    }

    function hasAtLeastOneValue($inputs) {
      var iterator = 0;
      $inputs.each(function () {
        if (hasValue($(this))) {
          iterator++;
        }
      });
      return iterator > 0;
    }

    function selectValues($inputs) {
      var values = [];
      $inputs.each(function () {
        const value = $(this).val();
        if (value) {
          values.push(value);
        }
      });
      return values;
    }

    function showServerValidation(response) {
      for (let fieldValue in response) {
        if (response.hasOwnProperty(fieldValue)) {
          if (response[fieldValue] === true) {
            $(`#${fieldValue.toString()}`).show();
          }
        }
      }
    }
  };

  return {
    init: init,
  };
})();
